export type TableSortDirection = 'asc' | 'desc';

export interface TableColumnSort<T extends string = string> {
    field: T;
    direction: TableSortDirection;
}

export const nextColumnSort = <T extends string>(field: T, current?: TableColumnSort<T>): TableColumnSort<T> => ({
    field,
    direction: current?.field === field && current.direction === 'asc' ? 'desc' : 'asc'
});
